import axiosInstance from "@/api/axios-instance";

// Re-pull name/questions/workspace from the form's provider.
export async function resyncForm(id: string) {
  const response = await axiosInstance.post(`/forms/${id}/resync`);
  return response.data;
}
